import { render } from "./Orders.vue?vue&type=template&id=f195c3b6&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=f195c3b6&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f195c3b6"]])

export default __exports__